import "core-js/modules/es.parse-int.js";
import { compose, withProps, setPropTypes, branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';
import NormalPrice from "./NormalPrice";
import DiscountedPrice from "./DiscountedPrice";
var enhancer = compose(withProps(function (_ref) {
  var charge = _ref.charge;
  var chargeTitleTip = charge.canceled && "".concat(charge.title, " - CANCELED") || charge.refunded && "".concat(charge.title, " - REFUNDED") || charge.title;
  var renderDiscountedPrice = parseInt(charge.price, 10) < parseInt(charge.original_price, 10);
  return {
    chargeTitleTip: chargeTitleTip,
    renderDiscountedPrice: renderDiscountedPrice
  };
}), branch(function (_ref2) {
  var renderDiscountedPrice = _ref2.renderDiscountedPrice;
  return renderDiscountedPrice;
}, renderComponent(DiscountedPrice)), setPropTypes({
  charge: PropTypes.object,
  chargeTitleTip: PropTypes.string,
  renderDiscountedPrice: PropTypes.bool
}));
export default enhancer(NormalPrice);